import React, { Component } from 'react'
import PropTypes from 'prop-types'
import lodash, { get } from 'lodash'
import uuid from 'uuid'
import { withRouter } from 'react-router'
import { reduxForm, reset, getFormValues } from 'redux-form'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import queryString from 'query-string'

function decorator(config) {
  return ComposedComponent => {
    @reduxForm(
      {
        form: config.form,
        destroyOnUnmount: !config.persist
      },
      { reset }
    )
    @connect(state => ({
        filterFormValues: getFormValues(config.form)(state)
      }),
      { push })
    @withRouter
    class Filter extends Component {
      static propTypes = {
        setFilter: PropTypes.func.isRequired,
        setInitialParams: PropTypes.func,
        disablePersistedFilter: PropTypes.bool,
        query: PropTypes.string,
        change: PropTypes.func,
        handleSubmit: PropTypes.func,
        pristine: PropTypes.bool,
        initialize: PropTypes.func,
        destroy: PropTypes.func,
        push: PropTypes.func,
        options: PropTypes.object,
        router: PropTypes.object,
        routes: PropTypes.array,
        location: PropTypes.object,
        reset: PropTypes.func,
        route: PropTypes.object,
        filterFormValues: PropTypes.object
      }

      componentDidMount() {
        const { filterFormValues } = this.props

        const query = queryString.parse(get(this.props, 'location.search'))

        let filterFields =
          get(query, 'filter') && JSON.parse(query.filter)

        if (!filterFields) {
          filterFields = filterFormValues
        }

        if (!filterFields && config.defaultFilter) {
          filterFields = config.defaultFilter
        }

        filterFields = filterFields || {}

        this.handleFilterCreate(filterFields)
        this.props.initialize(filterFields)
      }


      componentWillUnmount = () => {
        if (!config.persist) {
          this.props.setFilter('')
          this.props.destroy(config.form)
        }
      }

      key = uuid.v1()


      reduceFields = fields => {
        const { options = {} } = this.props

        let newFields = {}

        Object.keys(fields).forEach(key => {
          if (fields[key]) {
            newFields = {
              ...newFields,
              [key]: options[key]
                ? options[key][0].label
                : fields[key]
            }
          }
        })

        if (lodash.isEmpty(newFields)) {
          newFields = undefined
        }

        return newFields
      }


      mapToFields = (fields, field) => {

        let newFields = {}

        fields.map(item => {
          newFields = Object.assign({}, newFields, item)
        })

        if (lodash.isEmpty(newFields)) {
          newFields = undefined
        }

        this.props.change(field, null)
        this.handleFilterCreate(newFields)
      }


      handleFilterCreate = filterFields => {

        const reducedFields = this.reduceFields(filterFields)

        this.handleSetFilter(reducedFields)
      }


      handleSetFilter = (filterFields) => {

        const { location, disablePersistedFilter } = this.props

        const filterString = JSON.stringify(filterFields)

        !disablePersistedFilter &&
        this.props.push({
          ...location,
          pathname: location.pathname,
          query:
            filterFields
              ? {
                filter: filterString
              }
              : ''
        })

        if (!filterString) {
          this.props.destroy(config.form)
        }

        this.props.setFilter(filterString)
      }


      render() {
        const { filterString, handleSubmit } = this.props

        return (
          <form key={this.key} onSubmit={(x,y,z) => {
            return (handleSubmit(this.handleFilterCreate))(x,y,z)
          }}>
            <ComposedComponent
              {...this.props}
              query={filterString}
              onQueryUpdate={this.mapToFields}
              setFilter={this.handleSetFilter}
            />
          </form>
        )
      }
    }

    return Filter
  }
}

export default decorator
